export default __webpack_public_path__ + "static/media/outdoor_lamp_banners_original.17b1ab80.jpg";